import React, { useEffect, useState } from "react";
interface CounterProps {
  target: string | number;
  duration?: number;
  delay?: number; // delay before counting starts
}

const Counter: React.FC<CounterProps> = ({ target, duration = 2000, delay = 0 }) => {
  const [count, setCount] = useState(0);

  const numericTarget = typeof target === "string" ? parseFloat(target.replace(/[^0-9.]/g, "")) : target;
  const suffix = typeof target === "string" ? target.replace(/[0-9.]/g, "") : "";

  useEffect(() => {
    if (isNaN(numericTarget) || numericTarget <= 0) return;

    const timeout = setTimeout(() => {
      let start = 0;
      const increment = numericTarget / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= numericTarget) {
          setCount(numericTarget);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);

      return () => clearInterval(timer);
    }, delay);

    return () => clearTimeout(timeout);
  }, [numericTarget, duration, delay]);

  return <>{count}{suffix}</>;
};





export default Counter;
